import classnames from "classnames";
import React from "react";

import RadioChecked from "../../public/svg/icon-radio-checked.svg";
import RadioUnchecked from "../../public/svg/icon-radio-unchecked.svg";

import css from "./Radio.module.scss";

export const TEST_ID_RADIO = "radio";
export const TEST_ID_RADIO_CHECKED_ICON = "radio-checked-icon";
export const TEST_ID_RADIO_UNCHECKED_ICON = "radio-unchecked-icon";
export const TEST_ID_RADIO_INPUT = "radio-input";

interface RadioProps {
  checked: boolean;
  disabled?: boolean;
  label: string;
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const Radio: React.FC<RadioProps> = ({
  checked,
  disabled,
  label,
  name,
  value,
  onChange,
}) => {
  const id = `${name}-${value}`;
  return (
    <div
      className={classnames(css.container, disabled && css.disabled)}
      data-testid={TEST_ID_RADIO}
    >
      <label htmlFor={id}>
        {checked ? (
          <RadioChecked data-testid={TEST_ID_RADIO_CHECKED_ICON} />
        ) : (
          <RadioUnchecked data-testid={TEST_ID_RADIO_UNCHECKED_ICON} />
        )}
        {label}
        <input
          id={id}
          type="radio"
          checked={checked}
          disabled={disabled}
          data-testid={TEST_ID_RADIO_INPUT}
          value={value}
          onChange={onChange}
        />
      </label>
    </div>
  );
};

export default Radio;
